// Module
var code = "<div class=\"modal fade\" id=\"confirmApplyAllForGroup\"> <wt-modal yes-function=\"vm.apply()\" modal-title=\"{{'Push all modifications'|translate}}\"> <span> {{'Do you want to push all modifications from template to current group?'|translate}} </span> <br/> <span> {{'This operation cannot be undone.'|translate}} </span> </wt-modal> </div>";
// Exports
module.exports = code;